export default __webpack_public_path__ + "static/media/offroad260000.c9be07d7.jpg";